// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M_tyLx_fZJZqopmQnqVr{width:100%}`, "",{"version":3,"sources":["webpack://./src/shared/ui/Schedule/ui/SendingHours/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA","sourcesContent":[".picker {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"picker": `M_tyLx_fZJZqopmQnqVr`
};
export default ___CSS_LOADER_EXPORT___;
